import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import '../assets/css/button.css';
import '../assets/css/candidate-thank-you.css';
import TickGreenBigIcon from '../assets/img/tick-green-big-icon.svg';
import CustomRatingRadio from './CustomRatingRadio';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLogout } from '../Actions/logoutAction';
import _ from "lodash";
import { saveFeedback } from '../Actions/feedbackAction';
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import { base_url_client } from '../Constants/config';

const ClientThankYou = (props)=> {

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }


    return (
      <>

      <ClientHeader/>
      <ClientSideBar/>
      <section className="main-section h-100 thank-you-page" style={{paddingTop: '60px'}}>
        <div className="container">
          <div className="row mt-5">
            <div className="col-md-12 text-center mb-5">
              <img src={TickGreenBigIcon} alt="" width="70"/>
              {/* <h3 className="fnt-smi-bld mb-0 mt-3">Thank you</h3>
              <p className="text-muted">Your submission has been recieved successfully!</p> */}
              <h3 className="fnt-smi-bld my-2" style={{ fontSize: clientId == 459831 ? '80px' : ''}}>Thank you</h3>
                <p className="text-muted my-2" style={{fontSize:  clientId == 459831 ? 'large' : ''}}>
                  { clientId != 459831 ? 'Your submission has been recieved successfully!' :
                  'You have successfully submitted your profile'}
                </p>
             
            </div>
          </div>

          <div className="row mt-4 ml-3">
            <div className="col-md-12 text-center mb-4">
              <div className="d-flex justify-content-center flex-column-mbl">
                {/* <button className="btn btn-primary btn-lg mr-2 btn-block-mbl mb-1-mbl">Back to Home</button> */}
                <a href={base_url_client + "/listing-page?flag=true"} style={{color:"#fff", textDecoration:"none"}}>
                <button className="btn btn btn-primary btn-lg mr-2 btn-block-mbl" style={{width:428, height:44}}>
                  View Details
                </button></a>
              </div>
              <div className="d-flex justify-content-center flex-column-mbl mt-3">
                {/* <button className="btn btn-primary btn-lg mr-2 btn-block-mbl mb-1-mbl">Back to Home</button> */}
                <a href={base_url_client + "/dashboard/ivc-add/initiateMode?flag=true"} style={{textDecoration:"none"}}>
                <button className="btn btn btn-primary btn-lg mr-2 btn-block-mbl" style={{width:428, height:36, backgroundColor: "#EFF8FF",color: "#175CD3"}}> + Add Another Candidate
                </button>
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>

      </>
    );
}
export default ClientThankYou;